import { skipToken, useQuery, type UseQueryResult } from '@tanstack/react-query'
import { signService } from '@/services/SignService'
import { qaKeys } from '@/hooks/queryKeys'
import type { QaSessionDto } from '@lib/dto/question.dto'

export function useQaSession(token: string | undefined): UseQueryResult<QaSessionDto> {
  return useQuery({
    queryKey: qaKeys.session(token),
    queryFn: token ? () => signService.getQaSession(token) : skipToken,
    retry: false,
  })
}
